"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoveryDay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const structural_organisms_1 = require("../structural-organisms");
const RecoveryDayTable_1 = require("./RecoveryDayTable");
const card_1 = require("../../molecules/card");
const typography_1 = require("../../shared/typography");
const hooks_1 = require("../../shared/hooks");
const renderRows_1 = require("./renderRows");
const TableHeader_1 = require("../recovery-week-overview/TableHeader");
const RecoveryDay = (props) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    if (isMobile) {
        return ((0, jsx_runtime_1.jsxs)(structural_organisms_1.ListWithMargin, { children: [(0, jsx_runtime_1.jsx)(MobileWrapper, { children: (0, jsx_runtime_1.jsx)(card_1.CollapsableCard, { header: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: props.translations.recoveryTitle }, void 0), children: (0, renderRows_1.renderMobile)(props.recoveryValues) }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)(MobileWrapper, { children: [props.showChecklistChange && ((0, jsx_runtime_1.jsx)(TableHeader_1.DisplayChecklistChangeMessage, { onLogbookClick: props.onLogbookClick }, void 0)), (0, jsx_runtime_1.jsx)(card_1.CollapsableCard, { header: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: props.translations.progressTitle }, void 0), children: (0, renderRows_1.renderProgressionDay)(props.progressionValues) }, void 0)] }, void 0)] }, void 0));
    }
    return ((0, jsx_runtime_1.jsx)(WebListWithMargins, { children: [
            (0, jsx_runtime_1.jsx)(RecoveryDayTable_1.RecoveryDayTable, { title: props.translations.recoveryTitle, children: (0, renderRows_1.renderWeb)(props.recoveryValues) }, "web_recovery"),
            props.showChecklistChange ? ((0, jsx_runtime_1.jsx)(TableHeader_1.DisplayChecklistChangeMessage, { onLogbookClick: props.onLogbookClick }, void 0)) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0)),
            (0, jsx_runtime_1.jsx)(RecoveryDayTable_1.RecoveryDayTable, { title: props.translations.progressTitle, children: (0, renderRows_1.renderProgressionDay)(props.progressionValues) }, "web_progress")
        ] }, void 0));
};
exports.RecoveryDay = RecoveryDay;
const WebListWithMargins = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};
`;
const MobileWrapper = styled_components_1.default.div `
  & > div h2 {
    flex: 1;
    margin-bottom: 0;
  }

  & > div > div > div {
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};
  }

  & > div > div > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }

  & > div > div:last-of-type {
    padding-top: 0;
  }
`;
//# sourceMappingURL=RecoveryDay.js.map